import GuestLayout from '@/Layouts/GuestLayout';
import {Head, Link, useForm, usePage} from '@inertiajs/react';
import {Col, Form, Image, Row, Alert} from "react-bootstrap";
import React from "react";

export default function Login({status}) {
    const {flash} = usePage().props;
    const {data, setData, post, processing, errors, reset} = useForm({
        email: '',
        password: '',
        remember: false,
    });

    const submit = (e) => {
        e.preventDefault();
        post(route('auth.teacher.postLogin'), {
            onFinish: () => reset('password'),
        });
    };

    return (
        <GuestLayout>
            <Head title="Teacher Login"/>
            <div className="auth-main-content m-auto m-1230 px-3">
                <Row className="align-items-center">
                    <Col lg={6} className="d-none d-lg-block">
                        <Image
                            src="/images/login.jpg"
                            className="rounded-3"
                            alt="login"
                            width={646}
                            height={804}
                        />
                    </Col>

                    <Col lg={6}>
                        <div className="mw-480 ms-lg-auto">
                            <div className="d-flex align-items-center mb-5">
                                <Image
                                    src="/images/yv_only_logo.png"
                                    className="rounded-3 for-light-logo me-2"
                                    alt="login"
                                    width={70}
                                    height={70}
                                />
                                <Image
                                    src="/images/yv_only_logo.png"
                                    className="rounded-3 for-dark-logo me-2"
                                    alt="login"
                                    width={100}
                                    height={26}
                                />
                                <h1 className="d-inline m-0 text-yv-secondary">Teacher Centre</h1>
                            </div>

                            {flash?.error && (
                                <Alert variant="danger" className="mb-4">{flash.error}</Alert>
                            )}
                            {flash?.success && (
                                <Alert variant="success" className="mb-4">{flash.success}</Alert>
                            )}

                            <Form onSubmit={submit}>
                                <Form.Group className="mb-4">
                                    <label className="label text-secondary">Email Address</label>
                                    <Form.Control
                                        type="email"
                                        className={"h-55" + (errors.email ? ' is-invalid' : '')}
                                        placeholder="example@email.com"
                                        value={data.email}
                                        autoComplete="username"
                                        onChange={(e) => setData('email', e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <label className="label text-secondary">Password</label>
                                    <Form.Control
                                        type="password"
                                        className={"h-55" + (errors.password ? ' is-invalid' : '')}
                                        placeholder="Type password"
                                        value={data.password}
                                        autoComplete="current-password"
                                        onChange={(e) => setData('password', e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Link href={route('auth.teacher.getForgotPassword')}
                                          className="fw-medium text-primary text-decoration-none">
                                        Forgot Password?
                                    </Link>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <button
                                        type="submit"
                                        className="btn btn-primary fw-medium py-2 px-3 w-100"
                                        disabled={processing}
                                    >
                                        <div className="d-flex align-items-center justify-content-center py-1">
                                            <span className="material-symbols-outlined fs-20 text-white me-2">
                                                login
                                            </span>
                                            <span>Sign In</span>
                                        </div>
                                    </button>
                                </Form.Group>

                                <Form.Group>
                                    <p>
                                        Not a member yet?{" "}
                                        <Link
                                            href={route('auth.teacher.getRegister')}
                                            className="fw-medium text-primary text-decoration-none"
                                        >
                                            Sign Up
                                        </Link>
                                    </p>
                                </Form.Group>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </div>
        </GuestLayout>
    );
}
